import { GlobalModule } from 'utils/i18n/TModules';

// // Translation Keys
export const GlobalListPageKey = `globalList`;
export const GlobalPageHeaderKey = `globalPageHeader`;
export const CampaignTypesKey = `campaignTypes`;
export const UtilsTypesKey = `utilsTypes`;
export const TableTypesKey = `tableTypes`;
export const TextEditorKey = `textEditor`;

// // Translation Paths
export const TGlobalListPage = `${GlobalModule}:${GlobalListPageKey}`;
export const TGlobalPageHeader = `${GlobalModule}:${GlobalPageHeaderKey}`;
export const TCampaignTypes = `${GlobalModule}:${CampaignTypesKey}`;
export const TUtilsTypes = `${GlobalModule}:${UtilsTypesKey}`;
export const TTableTypes = `${GlobalModule}:${TableTypesKey}`;
export const TTextEditor = `${GlobalModule}:${TextEditorKey}`;
